import { Route } from '../../store';
import { CommonContainer } from './common/container';

export const strategyRoutes: Route[] = [
  {
    path: '/strategy/:strategyId/:strategyVersionId',
    component: CommonContainer,
  },
];
